// extracted by mini-css-extract-plugin
module.exports = {"icon":"card-subcontent_icon__KAI_l","iconList":"card-subcontent_iconList__GyL5z","iconListItem":"card-subcontent_iconListItem__SO_wB"};